import usersActionCreators from "Areas/Settings/users/redux/actionCreators";
import { getUsersData } from "Areas/Settings/users/redux/selectors";
import { security } from "Common/permissions";
import { connect } from "react-redux";
import panelActionCreators from "../accessLevelsEditorPanel/redux/actionCreators";
import AccessLevels from "./accessLevels";
import actionCreators from "./redux/actionCreators";
import { buildReduxAccessLevelKey, getAccessLevels, getInProgress, getIsOpen } from "./redux/selectors";
const mapStateToProps = (state, ownProps) => {
    const isOpen = getIsOpen(state);
    return {
        inProgress: getInProgress(state, ownProps.entityId, ownProps.entityType),
        data: getAccessLevels(state, ownProps.entityId, ownProps.entityType),
        users: getUsersData(state),
        selfUserId: security.getCurrentUserId(),
        open: isOpen === undefined ? ownProps.defaultOpen : isOpen
    };
};
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (objectId, entity) => {
        dispatch(usersActionCreators.getUsers());
        dispatch(actionCreators.getPermissions(objectId, entity));
    },
    onEdit: (objectId, entity) => dispatch(panelActionCreators.setAccessLevelsKey(buildReduxAccessLevelKey(objectId, entity))),
    onCreate: () => dispatch(panelActionCreators.setAccessLevelNew(true)),
    onChangeOpen: (isOpen) => dispatch(actionCreators.setIsOpen(isOpen))
});
export default connect(mapStateToProps, mapDispatchToProps)(AccessLevels);
